import { useMutation, useRequest } from "@umijs/max";
import React, { useState, useEffect } from 'react';
import { getMarketingCalendarList } from "../services/MarketingCalendar";
import {
  taskIdDesign,
  http_essayPolish
} from '@/services/PublicApi';

const chuangkit = () => {
  const { loading: taskIdDesignloading, data: designItem, run: handleTaskDesign, cancel: handleTaskDesignCancel } =
    useRequest(async ({ taskId }) => {
      const result = await taskIdDesign(taskId);
      if (result.status === 0) {
        console.log("文案润色成功", result.payload)
        return result.payload
      }
      return ""
    },{
      manual: true,
    }
  );



  return {
    taskIdDesignloading,
    handleTaskDesign,
    handleTaskDesignCancel,
    designItem
  }
};

export default chuangkit;
